import { render, staticRenderFns } from "./TaskFilter.vue?vue&type=template&id=02680a54&scoped=true&"
import script from "./TaskFilter.vue?vue&type=script&lang=js&"
export * from "./TaskFilter.vue?vue&type=script&lang=js&"
import style0 from "./TaskFilter.vue?vue&type=style&index=0&id=02680a54&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02680a54",
  null
  
)

export default component.exports